function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.048.972c.297-.927 1.607-.927 1.904 0l2.13 6.646a1 1 0 00.953.695h6.921c.966 0 1.37 1.233.593 1.805l-5.623 4.143a1 1 0 00-.36 1.11l2.143 6.685c.296.924-.764 1.686-1.545 1.11l-5.57-4.103a1 1 0 00-1.187 0l-5.57 4.104c-.782.575-1.842-.187-1.546-1.11l2.142-6.686a1 1 0 00-.359-1.11L.45 10.118c-.777-.572-.372-1.805.594-1.805h6.921a1 1 0 00.953-.695l2.13-6.646z",
  fill: "#FFC800"
});

var SvgFullStar = function SvgFullStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgFullStar;